export default class AppSettings {
  hardwareServerAddress: string = "pi.gigalot.systems";
  hardwareServerRestfulPort: string = "9000";
  hardwareServerReaderPort: string = "8004";

  onsiteServerAddress: string = "pi.gigalot.systems";
  onsiteServerRestfulPort: string = "443";

  secureProtocol: boolean = true;

  // hardwareServerAddress: string = "192.168.11.122";
  // hardwareServerRestfulPort: string = "9004";
  // hardwareServerReaderPort: string = "8044";

  // onsiteServerAddress: string = "127.0.0.1";
  // onsiteServerRestfulPort: string = "8443";

  // secureProtocol: boolean = false;

  cloudServerAddress: string = "gigalot.systems";
  //cloudServerRestfulPort: string = "";

  getRestfulProtocol() {
    return this.secureProtocol ? "https" : "http";
  }

  getWebSocketProtocol() {
    return this.secureProtocol ? "wss" : "ws";
  }

  isDarkMode: boolean = false;
}
